export default __webpack_public_path__ + "static/media/user_edited_fill.ec7dd2a4.svg";